module.exports = __webpack_public_path__ + "img/bi.761c83b8.svg";